
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import BacCountdown from '@/components/BacCountdown.vue'
import BacRodeoTile from '@/components/BacRodeoTile.vue'
import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import { CustomerRegister } from '../lib/models/CustomerRegister'
import AllRallyRounds from '@/components/admin/AllRallyRounds.vue'
import { Http } from '@/lib/utils/Http'
import { RallyRoundButton } from '@/lib/models/RallyRoundButton'
import UIkit from 'uikit'
import { RallyRound } from '../lib/models/RallyRound'

import WildcardFriend from '../components/your-rallies/WildcardFriend.vue'

@Component({
  components: {
    BacLoggedInHeader,
    BacRodeoTile,
    AllRallyRounds,
    BacCountdown,
    BacButton,
    BacModal,
    WildcardFriend
  }
})
export default class YourRallies extends Vue {
  newsletterType = 'alle'
  mounted () {
    window.location.href = '/app'
    this.checkLogin()
    this.$store.dispatch('loadRegisterRallyRounds')
    setTimeout(() => {
      console.log(this.registerRallyRounds)
    }, 3000)
  }

  async checkLogin () {
    const res = await (Http.request('/api/auth/check-login'))
    if (res.status !== 200) {
      window.location.replace('/teamarea/login')
    }
  }

  get showWildcardButton (): boolean {
    return this.registerRallyRounds
      .filter((register: CustomerRegister) => register.status === 2 || register.status === 1)
      .length > 0
  }

  get hasRallyThisYear (): boolean {
    let has = false
    this.registerRallyRounds.filter((registerRallyRound: CustomerRegister) => {
      if (new Date(registerRallyRound.createdAt as string).getFullYear() === (new Date()).getFullYear()) {
        has = true
      }
    })
    return has
  }

  get pastSortedRegisterRallyRounds () {
    return this.sortedRegisterRallyRounds.filter((registerRallyRound: CustomerRegister) => {
      if (registerRallyRound.rallies.length && registerRallyRound.rallies[0].rounds.length && registerRallyRound.rallies[0].rounds[0].dateEnd) {
        return new Date(registerRallyRound.rallies[0].rounds[0].dateEnd).getTime() - new Date().getTime() < 0 && registerRallyRound.status !== 3
      }
    })
  }

  get upcomingSortedRegisterRallyRounds () {
    return this.sortedRegisterRallyRounds.filter((registerRallyRound: CustomerRegister) => {
      if (registerRallyRound.rallies.length && registerRallyRound.rallies[0].rounds.length && registerRallyRound.rallies[0].rounds[0].dateEnd) {
        return new Date(registerRallyRound.rallies[0].rounds[0].dateEnd).getTime() - new Date().getTime() > 0 && registerRallyRound.status !== 3
      }
    })
  }

  get sortedRegisterRallyRounds () {
    return this.registerRallyRounds.sort((a: CustomerRegister, b: CustomerRegister) => {
      if (
        a.rallies.length && b.rallies.length &&
      a.rallies[0].rounds.length && b.rallies[0].rounds.length &&
      a.rallies[0].rounds[0].dateBegin && b.rallies[0].rounds[0].dateBegin) {
        return a.rallies[0].rounds[0].dateBegin > b.rallies[0].rounds[0].dateBegin
      }
    })
  }

  get registerRallyRounds () {
    if (this.$store.state.LoggedInUser.registerRallyRounds && this.$store.state.LoggedInUser.registerRallyRounds.length) {
      return this.$store.state.LoggedInUser.registerRallyRounds
    } else if (localStorage.getItem('logged-in-user.register-rally-rounds')) {
      const localStorageJson = localStorage.getItem('logged-in-user.register-rally-rounds')
      if (!localStorageJson) {
        return []
      }
      const localStorageData = JSON.parse(localStorageJson)
      if (Array.isArray(localStorageData) && localStorageData.length) {
        return localStorageData
      } else {
        return []
      }
    } else {
      return []
    }
  }

  @Watch('upcomingSortedRegisterRallyRounds')
  onUpcomingRallyRoundsChange () {
    this.upcomingSortedRegisterRallyRounds.map(async (rallyRound: RallyRound) => {
      const rallyRoundId = (rallyRound as any).rallies[0].rounds[0].id
      // deactivate on 1.1. for performance
      // localStorage.setItem(
      // `rally-round-${rallyRoundId}-buttons`,
      // JSON.stringify(await RallyRoundButton.getAll({ params: [rallyRoundId, 'buttons'] }))
      // )

      // check if a rally is currently on, if so redirect to chat (or one day before)
      const today = Date.now()
      const dateBegin = new Date((rallyRound as any).rallies[0].rounds[0].dateBegin).getTime() - (86400 * 1000)
      const dateEnd = new Date((rallyRound as any).rallies[0].rounds[0].dateEnd).getTime()

      if (today - dateBegin > 0 && // today is after dateBegin, should be enough since we're talking about upcoming rallies
        today - dateEnd < 0 && // still check if rally is not over
        (rallyRound as any).status === 2 // also check correct status, don't forward unpaid e.g.
      ) {
        if (!this.$store.state.LoggedInUser.hasBeenForwardedToActiveRallyRound) {
          this.$store.commit('hasBeenForwarded')
          this.$router.push(`/rally/${(rallyRound as any).rallies[0].rounds[0].id}`)
        }
      }
    })
  }

  async signUpForNewsletter () {
    const res = await Http.request('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ newsletterType: this.newsletterType })
    })
    if (res.status === 200) {
      UIkit.notification({
        message: 'Erfolreich angemeldet!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      UIkit.modal('#rally-registration-notification-modal').hide()
    } else {
      UIkit.notification({
        message: 'Es ist ein unbekannter Fehler aufgetreten! Bitte schildere uns was passiert ist unter hello@backroadclub.com',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    }
  }
}
